import React from "react";
import { Row, Col, Divider } from "antd";

//component
import IncomeReceivable from "./component/income_receivables";
import VoucherRedeemList from "./component/voucher_redeemed";
import CreditNoteRedeemed from "./component/credit_note_redeemed";
import CashupTotal from "./component/cashup_total";
import Evidence from "./component/cashup_evidence";
import CashupRefund from "./component/cashup_refund";
import CashupDiscount from "./component/cashup_discount";

const IncomeReceivableDetail = ({
  edit,
  fileList,
  setFileList,
  totalReceive,
  setTotalReceive,
  sumTotal,
}) => {
  // -------------------------- VAR --------------------------
  // -------------------------- STATE --------------------------

  // -------------------------- REDUX --------------------------

  // -------------------------- FUNCTION --------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN --------------------------
  return (
    <Col
      style={{
        borderColor: "#d9d9d9",
        borderWidth: "1px",
        borderStyle: "solid",
        borderRadius: "10px",
        marginTop: 10,
      }}
    >
      <Col xl={24} lg={24} md={24} xs={24} align="left">
        <CashupTotal total={sumTotal} color="red" />
      </Col>
      <Col xl={24} lg={24} md={24} xs={24} align="left">
        <IncomeReceivable
          edit={edit}
          total={totalReceive}
          setTotal={setTotalReceive}
        />
      </Col>
      <Col xl={24} lg={24} md={24} xs={24} align="left">
        <VoucherRedeemList edit={edit} />
      </Col>
      <Col xl={24} lg={24} md={24} xs={24} align="left">
        <CreditNoteRedeemed edit={edit} />
      </Col>
      <Col xl={24} lg={24} md={24} xs={24} align="left">
        <CashupDiscount edit={edit} />
      </Col>
      <Col xl={24} lg={24} md={24} xs={24} align="left">
        <Evidence edit={edit} fileList={fileList} setFileList={setFileList} />
      </Col>
    </Col>
  );
};

export default IncomeReceivableDetail;
